import { Component, Testability } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController
} from "ionic-angular";
import * as papa from "papaparse";
import { DatabaseProvider } from '../../providers/database/database';
import * as moment from "moment";
import * as _ from "lodash";
import { AuthProvider } from "../../providers/auth/auth";

@IonicPage()
@Component({
  selector: "page-patient-upload",
  templateUrl: "patient-upload.html"
})
export class PatientUploadPage {
  uploadedPatients: Array<Object> = [];
  message: string = null;
  clinic_name: string = null;
  clinic_id: string = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider
  ) {

    this.auth.getCurrentUser().then(user => {
      console.log(user);
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad PatientUploadPage");
  }

  parseCSV(files: FileList): void {
    let loading = this.loadingCtrl.create({
      content: "Uploading and checking patient info..."
    });

    loading.present().then(_ => {
      const file: File = files.item(0);
      const reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = e => {
        const csv = reader.result;
        //const parsed = papa.parse(csv, {
        papa.parse(csv, {
          // dynamicTyping: true,
          header: true,
          complete: () => {
            console.log("Completed Data", this.uploadedPatients);
            loading.dismiss();
          },
          error: error => {
            console.error(error.message);
            loading.dismiss();
          },
          step: row => {
            // Add Fullname
            row.data[0]["full_name"] = row.data[0]["first_name"] + ' ' + row.data[0]["last_name"];

            // FIX Male v Female
            if (row.data[0]["gender"] === "Male") {
              row.data[0]["gender"] = "MALE";
            } else {
              row.data[0]["gender"] = "FEMALE";
            }

            // Fix 2 digit date problem
            //console.log("Original DOB: ", row.data[0]["dob"]);
            let datearray = row.data[0]["dob"].split("/");
            let day = datearray[1];
            let month = datearray[0];
            let year = datearray[2];
            if(year.length < 3) {
            if(parseInt("20" + year) < parseInt((new Date()).getFullYear().toString())) {
              year = "20" + year;
            }
            else {
              year = "19" + year;
            }
          }
            let newdatestring = year + "-" + month + "-" + day;
            console.log("New Date String: ", newdatestring);
            //let newDOB:Date = moment(newdatestring, "D-MMM-YYYY").toDate();
            
            row.data[0]["dob"] = newdatestring
            //console.log("New DOB: ", row.data[0]["dob"]);

            // do phone number
            let phone = row.data[0]["phone_number_primary"]
            if(phone === null || phone === '') {
              let phone_other = row.data[0]["phone_number_other"]
              if(phone_other !== null || phone_other !== '') {
                row.data[0]["phone_number_primary"] = phone_other;
                row.data[0]["phone_number_other"] = null;
              }
            }
            //row.data[0]["phone_number_primary"] = phone;
            //console.log("Phone Number: ", row.data[0]["phone_number"]);

            // update email address
            let now = moment().valueOf();
            let email = row.data[0]["email"]
            if (email === null || email === '') { email = null; } 
            row.data[0]["email"] = email;

            // push patient to array
            this.uploadedPatients.push(row.data[0]);
            //console.log(row.meta.cursor / csv.size * 100);
          }
        });
        //this.uploadedPatients = parsed.data;
        // do something with parsed CSV
      };
    });
  }

  completeUpload() {
    let confirm = this.alertCtrl.create({
      title: "Add Patients to Opteva",
      message:
        "Are you sure you would like to add " +
        this.uploadedPatients.length +
        " to Opteva Direct?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't upload patients");
          }
        },
        {
          text: "Yes",
          handler: () => {
            _.forEach(this.uploadedPatients, row => {
              this.savePatient(row);
            });
          }
        }
      ]
    });
    confirm.present();
  }

  async savePatient(row) {
    const updatedrow = await this.database
      .addPatient(this.clinic_id, row)
      .then(response => {
        row.id = response["data"].id;
        console.log("Response from patient save: ", response);
        return true;
      })
      .catch(err => {
        console.log("There was a problem saving the patient info: ", err);
        return false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-upload/patient-upload.ts